import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '../auth.service';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit {
  @ViewChild('form') form: NgForm;

  newuser = {
    email: '',
    password: '',
    displayName: '',
    nivel: ''
  }
  constructor(
    public authService: AuthService,
    private router: Router
  ) { }

  ngOnInit() {}

  signup() {
    if (this.newuser.email == '' || this.newuser.password == '' || this.newuser.displayName == '') {
      alert('Todos os campos são necessários');
    }
    else if (this.newuser.password.length < 7) {
      alert('Password fraca. Coloque mais de 6 caracteres, por favor');
    }
    else {
      this.authService.emailSignup(this.newuser).then((res: any) => {
        if (this.newuser.nivel == '1'){
          this.router.navigateByUrl('/profile');
        }else{
          this.router.navigateByUrl('/documentos');
        } 
      })
    }
  } 
}


// WEBPACK FOOTER //
// ./src/app/signup/signup.component.ts